/**
 * Honest post-payment customer copy. Never claim the store is active
 * before session.status === "active".
 */
export const ONBOARDING_CUSTOMER_COPY = {
  paymentPending: "Tu pago todavía no fue confirmado.",
  activating: "Estamos activando tu tienda.",
  paidFailed: "El pago fue confirmado pero necesitamos completar la activación.",
  active: "Tu tienda está activa.",
} as const;

export function onboardingCustomerCopyForSession(session: {
  status: string;
  paymentConfirmedAt?: string | null;
}): string {
  if (session.status === "active") return ONBOARDING_CUSTOMER_COPY.active;
  if (session.status === "failed" && session.paymentConfirmedAt) {
    return ONBOARDING_CUSTOMER_COPY.paidFailed;
  }
  if (session.status === "payment_confirmed" || session.status === "provisioning") {
    return ONBOARDING_CUSTOMER_COPY.activating;
  }
  return ONBOARDING_CUSTOMER_COPY.paymentPending;
}
